import { render } from "./ilos-add-component.vue?vue&type=template&id=416c6fa4&ts=true"
import script from "./ilos-add-component.vue?vue&type=script&lang=ts"
export * from "./ilos-add-component.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__